import React, { useState } from 'react'
import System from 'src/helper/system';
import { useForecastStore } from 'src/hooks/forecast';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';

const ShareForecastPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { SetStatus } = props;
    const [sendToEmail, setSendToEmail] = useState([{}])
    const [sendToEmailError, setSendToEmailError] = useState([])
    const [subject, setSubject] = useState("Forecast Report - " + Helper.dateFormatFromString(Date(),true))
    const [subjectError, setSubjectError] = useState('')
    const [message, setMessage] = useState('')
    const [messageError, setMessageError] = useState('')
    const [forecastType, setForecastType] = useState('')
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const [{ }, { }, { forecast_share }] = useForecastStore();
    const defaultSubject = "Forecast Report - " + Helper.dateFormatFromString(Date(),true);
    const { forecastCount } = props?.data;

    const addFormFields = () => {
        setSendToEmail([...sendToEmail, {}])
    }

    const handleChange = (i, e) => {
        let newSendToEmailError = [...sendToEmailError];

        if (e.target.value.length === 0) {
            newSendToEmailError[i] = true;
        } else if (!e.target.value.match(emailRegex)) {
            newSendToEmailError[i] = true;
        } else {
            newSendToEmailError[i] = false;
        }
        setSendToEmailError(newSendToEmailError);

        let newSendToEmail = [...sendToEmail];
        newSendToEmail[i] = e.target.value;
        setSendToEmail(newSendToEmail);
    }

    const removeFormFields = (i) => {
        let newSendToEmailError = [...sendToEmailError];
        let newSendToEmail = [...sendToEmail];

        newSendToEmail.splice(i, 1);
        setSendToEmail(newSendToEmail)
        newSendToEmailError.splice(i, 1)
        setSendToEmailError(newSendToEmailError);
    }

    const onSubjectChange = (value) => {
        if (value.trim().length > 99) {
            setSubjectError('Maximum 99 characters allowed')
        } else {
            setSubjectError('')
        }
        setSubject(value)
    }

    const onMessageChange = (value) => {
        if (value.trim().length > 999) {
            setMessageError('Maximum 999 characters allowed')
        } else {
            setMessageError('')
        }
        setMessage(value)
    }

    const onTypeChange = (value) => {
        setForecastType(value)
    }

    const shareForecast = async () => {
        let error = false
        if (sendToEmail && sendToEmail.length > 0) {
            let newSendToEmailError = [...sendToEmailError];
            sendToEmail.map((v, i) => {
                if (Object.entries(v).length === 0 || (v[i] && v[i].length === 0)) {
                    newSendToEmailError[i] = true;
                    error = true
                }
                setSendToEmailError(newSendToEmailError);
            })
        }

        if (subject.trim().length > 99) {
            setSubjectError('Maximum 99 characters allowed')
            error = true
        }

        if (message.trim().length > 999) {
            setMessageError('Maximum 999 characters allowed')
            error = true
        }

        if (sendToEmailError && sendToEmailError.length > 0 && sendToEmailError.includes(true)) {
            error = true
        }


        if (!error) {
            let params = {
                sendToEmails: sendToEmail,
                subject: subject || defaultSubject,
                message: message,
                filterOption: forecastType,
            };

            await forecast_share(
                params
            ).then(function (response) {
                if (response && response.payload && response.payload.data) {
                    System.popup('ShareForecastSuccessPopup', {});
                }
            });
        }

    }

    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Share Forecast</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="email">Which of the following would you like to share? </label>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio"
                                        name="forecast-type"
                                        id="forecast-type-all"
                                        value=""
                                        checked={forecastType === ""}
                                        onChange={(e) => {
                                            onTypeChange(e.target.value)
                                        }} disabled={forecastCount?.nonConstraint == 0 && forecastCount?.constraint == 0} />
                                    <label className="form-check-label" htmlFor="forecast-type-all">All ({forecastCount?.total ? forecastCount.total : 0})</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio"
                                        name="forecast-type"
                                        id="forecast-type-non-constraint"
                                        value="G"
                                        checked={forecastType === "G"}
                                        onChange={(e) => {
                                            onTypeChange(e.target.value)
                                        }}
                                        disabled={forecastCount?.nonConstraint == 0}
                                         />
                                    <label className="form-check-label" htmlFor="forecast-type-non-constraint">Non Constraint ({forecastCount?.nonConstraint ? forecastCount.nonConstraint : 0})</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio"
                                        name="forecast-type"
                                        id="forecast-type-constraint"
                                        value="R"
                                        checked={forecastType === "R"}
                                        placeholder={defaultSubject}
                                        onChange={(e) => {
                                             onTypeChange(e.target.value)
                                        }}
                                        disabled={forecastCount?.constraint == 0}
                                        />
                                    <label className="form-check-label" htmlFor="forecast-type-constraint">Constraint ({ forecastCount?.constraint ? forecastCount.constraint : 0})</label>
                                </div>
                            </div>


                            <div className="form-group bs5 mb-0">
                                <label htmlFor="email">Send To <span
                                    className="mandatory">*</span></label>
                                {sendToEmail.map((element, index) => (
                                    <>
                                        <div className="d-flex p-b-10" key={index}>
                                            <input type="text" name={"sendto-" + index}
                                                aria-label="Share via email"
                                                className="form-control"
                                                placeholder="email@address.com"
                                                onChange={(e) => {
                                                    handleChange(index, e)
                                                }}
                                                value={Object.keys(element).length > 0 ? element : ""}
                                            />

                                            {
                                                index ?
                                                    <button type="button"
                                                        className="remove-email btn-link text-black bs5 mb-0"><span
                                                            className="fa fa-times"
                                                            onClick={() => removeFormFields(index)} /><span
                                                                className="sr-only">Remove Email</span></button>
                                                    : null
                                            }
                                        </div>
                                        <p className="error bs5 mt-0 m-b-10">{sendToEmailError && sendToEmailError.length > 0 && sendToEmailError[index] === true && "Please enter a valid email address"}</p>
                                    </>
                                ))}
                            </div>

                            <a className={sendToEmail.length < 3 ? "add-more AddAnotherAddressDivOne mb-1 text-blue2" : "add-more AddAnotherAddressDivOne mb-1 text-blue2 d-none"}
                                onClick={() => addFormFields()}>+ Add another address</a>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="email">Subject</label>
                                <input
                                    type="text"
                                    name="Subject"
                                    className="avnet-textBox form-control form-control-sm"
                                    placeholder={defaultSubject}
                                    onChange={(e) => onSubjectChange(e.target.value)}
                                />
                                <p className="error">{subjectError.trim().length > 0 && subjectError}</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="email">Message</label>
                                <textarea name="name" rows="8" cols="60" className="avnet-textBox form-control form-control-sm"
                                    placeholder="Type your message.."
                                    onChange={(e) => onMessageChange(e.target.value)} value={message}></textarea>
                                <p className="error">{messageError.trim().length > 0 && messageError} </p>
                            </div>
                        </div>
                    </div>

                    {/* Modal footer */}
                    {__check(['SHARE_FORECAST_API_CALL']).render}
                    {!__check(['SHARE_FORECAST_API_CALL']).status &&
                        <div className="modal-footer text-center">
                            <div className="modal-footer-actions">
                                <button type="button" className="bs5 btn btn-secondary minw-auto"
                                    data-bs-toggle="modal"
                                    onClick={() => {
                                        SetStatus(false)
                                    }}>
                                    Cancel
                                </button>
                                <button type="submit" className="bs5 btn btn-primary minw-auto"
                                    data-bs-toggle="modal"
                                    onClick={() => {
                                        shareForecast()
                                    }}>
                                    Send
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default ShareForecastPopup